import { render, staticRenderFns } from "./AdminProductVendorInfoComponent.html?vue&type=template&id=0fab6fb4&"
import script from "./AdminProductVendorInfoComponent.js?vue&type=script&lang=js&"
export * from "./AdminProductVendorInfoComponent.js?vue&type=script&lang=js&"
import style0 from "./AdminProductVendorInfoComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports